import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    contentFingerprint: String,
    preview: Boolean,
    siteId: Number
  }

  connect() {
    if (this.previewValue) return

    if (this.dismissedFingerprint === this.contentFingerprintValue) {
      this.element.remove()
    } else {
      this.element.classList.remove("hidden")
    }
  }

  dismiss() {
    if (!this.previewValue) {
      this.rememberDismissal()
    }

    this.element.remove()
  }

  rememberDismissal() {
    try {
      localStorage.setItem(this.storageKey, this.contentFingerprintValue)
    } catch {
      return
    }
  }

  get dismissedFingerprint() {
    try {
      return localStorage.getItem(this.storageKey)
    } catch {
      return null
    }
  }

  get storageKey() {
    return `memberful.announcement.dismissed.${this.siteIdValue}`
  }
}
